import { AppBar, Container, Toolbar, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import './AppNavBar.css';

export default function AppNavBar() {
  return (<AppBar position="static">
    <Container maxWidth="xl">
      <Toolbar disableGutters>
        <Link className="logo-container" to='/'>
          <img className="logo" src={`${process.env.PUBLIC_URL}/img/plugin-logo.png`} alt="Global Plugin" />
        </Link>
        <Typography
          variant="h6"
          noWrap
          component="a"
          href="/"
          sx={{
            display: 'block',
            fontFamily: 'sans-serif',
            fontWeight: 700,
            color: '#75bfb0',
            textDecoration: 'none',
            width: '90%',
            textAlign: 'center'
          }}
        >
          NEW INVOICE
        </Typography>
        <span className="right-space"></span>
      </Toolbar>
    </Container>
  </AppBar>)
}